import type { IconName } from "./ui/Icon";

interface NavItem {
  to: string;
  label: string;
  icon: IconName;
  /** `end` marks routes that should only be active on an exact match (Home). */
  end?: boolean;
}

/** The operator app's places, in the top bar's order, with the prototype's icons. */
export const NAV_ITEMS: NavItem[] = [
  { to: "/", label: "Home", icon: "home", end: true },
  { to: "/rooms", label: "Rooms", icon: "play" },
  { to: "/assets", label: "Assets", icon: "fold" },
  { to: "/people", label: "People", icon: "users" },
  { to: "/automations", label: "Automations", icon: "zap" },
  { to: "/conversations", label: "Conversations", icon: "chat" },
  { to: "/settings", label: "Settings", icon: "sliders" },
];
